// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__hEwHl","ellipsis":"styles_ellipsis__Crnrg","text2AndMoreLines":"styles_text2AndMoreLines___lsAL","tooltipTrigger":"styles_tooltipTrigger__6Ocuq"};